export default __webpack_public_path__ + "static/media/apes.8d9d080c.gif";